<template>
    <div>
        <div class="d-flex justify-content-center">
            <img :src="imgSrc" class="w-50" :class="isDone ? 'd-none' : ''" />
        </div>
        <div class="graph-wrapper" v-if="hasRoles">
            <multicircle-graph :roles="roles"/>
        </div>
        <small class="text-opacity mb-1 d-block">{{ trans('courses.multicircle_exercise.collaboration_with') }}</small>
        <b-img :src="logoSrc" v-bind="{ height: 36, left: true }" />        
    </div>
</template>

<script>
    import MulticircleGraph from "../../multime/MulticircleGraph";

    export default {
        name: "MultimeWidgetCardContent",
        components: {
            MulticircleGraph
        },
        props: {
            isDone: Boolean | Number,
            hasRoles: Boolean,
            imgSrc: String,
            logoSrc: String,
            roles: Array | null
        },
    }
</script>

<style scoped lang="scss">
    .graph-wrapper {
        margin: -40px 0;
    }
</style>